import { RecordBase } from './RecordBase';

export class VisitorsRecord extends RecordBase {
    stat_date!: string;
    visitors!: number;
}
